var _rect, _radialGradient, _radialGradient2, _linearGradient, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Edge",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#ffffff"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.6,
    cy: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.5,
    cy: 0.6,
    fx: 0.2,
    fy: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#38c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#269"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#5ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7d5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439 374c-50 77-131 98-163 96-191-9-162-262-47-261-82 52 30 224 195 157 17-12 20 3 15 8",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311 255c18-82-31-135-129-135S38 212 38 259c0 124 125 253 287 203-134 39-214-116-146-210 46-66 123-68 132 3 M411 99h1",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 253C51-15 419-30 472 202c14 107-86 149-166 115-42-26 26-20-3-99-48-112-251-103-264 35",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.961dbda84351cdfc8b2123715f19e234.svg";
export { ForwardRef as ReactComponent };